import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

const IN = "min-h-[48px] rounded border border-erf-borderCream px-3 bg-white text-base";
const msg = (e) => e?.response?.data?.detail?.message || "Search failed.";

// B8: historical daily reports — by project / date range / trade / text, only projects you can read.
export default function FieldReportSearch() {
  const [f, setF] = useState({ q: "", trade: "", date_from: "", date_to: "" });
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const run = (e) => {
    e.preventDefault();
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    api.get("/field/reports", { params }).then((r) => { setRows(r.data.items); setErr(""); }).catch((x) => setErr(msg(x)));
  };
  const input = (k, label, type = "text") => (
    <label className="text-xs flex flex-col gap-1">{label}<input type={type} className={IN} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`field-search-${k}`} /></label>);
  return (
    <AppShell title="Daily reports" subtitle="Search past reports">
      <div className="mx-auto w-full max-w-[900px] px-4 space-y-4" data-testid="field-search">
        <form onSubmit={run} className="grid gap-2 sm:grid-cols-4 items-end">
          {input("q", "Text")}{input("trade", "Trade")}{input("date_from", "From", "date")}{input("date_to", "To", "date")}
          <button type="submit" className="min-h-[48px] px-4 rounded-sm bg-erf-dark text-white font-semibold sm:col-span-4" data-testid="field-search-submit">Search</button>
        </form>
        {err && <p role="alert" className="text-sm text-red-700" data-testid="field-search-error">{err}</p>}
        {rows && !rows.length && <p className="text-sm" data-testid="field-search-empty">No reports match.</p>}
        <ul className="space-y-2">{(rows || []).map((r) => (
          <li key={r.id}><Link to={`/field/reports/${r.id}`} className="block border border-erf-borderCream rounded bg-white p-3 text-sm hover:bg-erf-creamSecondary" data-testid={`field-search-row-${r.id}`}>
            <span className="font-semibold">{r.log_date} · {r.project_name}</span> · {r.state === "acknowledged" ? "Approved" : r.state}
            <span className="block break-words">{r.work_performed}</span></Link></li>))}
        </ul>
      </div>
    </AppShell>
  );
}
